"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextInputRequired = exports.StyledTextInputOptional = exports.StyledTextInputObject = exports.StyledTextInputLabel = exports.StyledTextInputError = exports.StyledTextInputContainer = exports.StyledAlertIconContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledTextInputError = _styledComponents["default"].div.withConfig({
  displayName: "TextInputstyles__StyledTextInputError",
  componentId: "sc-1p8syex-0"
})(["", " font-size:", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["sans-serif w-100 pt1\n    ", "\n  "])), function (props) {
  return props.theme.textInput.errorColor;
}), function (props) {
  return props.theme.textInput.errorMessageFontSize || '0.875rem';
});

exports.StyledTextInputError = StyledTextInputError;

var StyledTextInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextInputstyles__StyledTextInputContainer",
  componentId: "sc-1p8syex-1"
})(["", " border-width:", ";box-sizing:border-box;visibility:", ";", " &.error{", " input{", "}}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 relative\n    ", "\n    ", "\n    ", "\n  "])), function (props) {
  return props.floatingLabel ? 'ba' : '';
}, function (props) {
  return props.theme.textInput.borderRadius;
}, function (_ref) {
  var focus = _ref.focus,
      readOnly = _ref.readOnly,
      theme = _ref.theme;
  return focus && !readOnly ? theme.textInput.borderColorFocus : theme.textInput.borderColor;
}), function (props) {
  return props.theme.textInput.borderWidth;
}, function (props) {
  return props.visible ? 'visible' : 'hidden';
}, function (_ref2) {
  var _formComponents$input;

  var floatingLabel = _ref2.floatingLabel,
      formComponents = _ref2.theme.formComponents;
  return floatingLabel && (0, _styledComponents.css)(["height:", ";"], formComponents === null || formComponents === void 0 ? void 0 : (_formComponents$input = formComponents.inputDropdownHeight) === null || _formComponents$input === void 0 ? void 0 : _formComponents$input.normal);
}, (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (props) {
  return "b--".concat(props.theme.textInput.errorColor);
}), (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (props) {
  return "b--".concat(props.theme.textInput.errorColor);
}));

exports.StyledTextInputContainer = StyledTextInputContainer;

var StyledTextInputObject = _styledComponents["default"].input.withConfig({
  displayName: "TextInputstyles__StyledTextInputObject",
  componentId: "sc-1p8syex-2"
})(["&&{", " ", " font-size:", ";border-width:", ";box-sizing:border-box;text-indent:3px;", " ", " text-indent:0.5rem;:focus{outline:none;}}"], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n      w-100 h-100 pl1 sans-serif\n      ", "\n      ", "\n      ", "\n    "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.textInput.backgroundColor || 'bg-transparent';
}, function (_ref4) {
  var floatingLabel = _ref4.floatingLabel,
      theme = _ref4.theme;
  return floatingLabel ? 'bn' : "ba ".concat(theme.textInput.borderRadius);
}, function (_ref5) {
  var disabled = _ref5.disabled,
      theme = _ref5.theme;
  return disabled && "bg-".concat(theme.textInput.disabledBackground, " ").concat(theme.textInput.disabledText || theme.textInput.disabledLabel);
}), function (_ref6) {
  var _formComponents$input2;

  var floatingLabel = _ref6.floatingLabel,
      formComponents = _ref6.theme.formComponents;
  return !floatingLabel && (0, _styledComponents.css)(["height:", ";"], formComponents === null || formComponents === void 0 ? void 0 : (_formComponents$input2 = formComponents.inputDropdownHeight) === null || _formComponents$input2 === void 0 ? void 0 : _formComponents$input2.normal);
}, function (_ref7) {
  var formComponents = _ref7.theme.formComponents;
  return formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.input;
}, function (props) {
  return props.theme.textInput.borderWidth;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && 'cursor: not-allowed;';
}, function (_ref9) {
  var floatingLabel = _ref9.floatingLabel,
      theme = _ref9.theme;
  return floatingLabel ? (0, _styledComponents.css)(["padding:1rem 0 0.5rem 0;"]) : (0, _styledComponents.css)(["padding:0.625rem 0;", " :focus:not(:read-only){", "}"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["", ""])), theme.textInput.borderColor), (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["", ""])), theme.textInput.borderColorFocus));
});

exports.StyledTextInputObject = StyledTextInputObject;

var StyledTextInputLabel = _styledComponents["default"].label.withConfig({
  displayName: "TextInputstyles__StyledTextInputLabel",
  componentId: "sc-1p8syex-3"
})(["", " font-size:", ";", " ", " align-items:center;cursor:text;transition:all 0.15s ease;text-align:left;"], (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 h-100 ma0 pa0 border-box top-0 left-0 flex lh-solid\n    ", "\n    ", "\n    ", "\n  "])), function (_ref10) {
  var disabled = _ref10.disabled,
      theme = _ref10.theme;
  return disabled ? theme.textInput.disabledLabel : theme.textInput.label;
}, function (props) {
  return props.floatingLabel ? 'absolute' : 'mb2';
}, function (props) {
  return props.floatingLabel && props.focusOrFilled ? 'top--1 pt2' : '';
}), function (_ref11) {
  var formComponents = _ref11.theme.formComponents;
  return formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.label;
}, function (_ref12) {
  var floatingLabel = _ref12.floatingLabel,
      focusOrFilled = _ref12.focusOrFilled;
  return floatingLabel && (0, _styledComponents.css)(["", " text-indent:8px;pointer-events:none;"], focusOrFilled && 'font-size: 11px;');
}, function (_ref13) {
  var floatingLabel = _ref13.floatingLabel,
      formComponents = _ref13.theme.formComponents;
  return !floatingLabel && (0, _styledComponents.css)(["font-size:", ";"], formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.label);
});

exports.StyledTextInputLabel = StyledTextInputLabel;

var StyledTextInputRequired = _styledComponents["default"].span.withConfig({
  displayName: "TextInputstyles__StyledTextInputRequired",
  componentId: "sc-1p8syex-4"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref14) {
  var disabled = _ref14.disabled,
      theme = _ref14.theme;
  return disabled ? theme.textInput.disabledLabel : 'red';
}));

exports.StyledTextInputRequired = StyledTextInputRequired;

var StyledTextInputOptional = _styledComponents["default"].span.withConfig({
  displayName: "TextInputstyles__StyledTextInputOptional",
  componentId: "sc-1p8syex-5"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.textInput.optional || 'dark-gray';
}));

exports.StyledTextInputOptional = StyledTextInputOptional;

var StyledAlertIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextInputstyles__StyledAlertIconContainer",
  componentId: "sc-1p8syex-6"
})(["", " width:1.5rem;bottom:4px;right:0.6rem;& > svg{", " width:100%;height:100%;}"], (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["nl1 absolute"]))), function (props) {
  return "\n      stroke: var(--".concat(props.theme.textInput.errorColor, ");\n      fill: var(--").concat(props.theme.textInput.errorColor, ");\n    ");
});

exports.StyledAlertIconContainer = StyledAlertIconContainer;